import { FEATURE_FLAGS } from '../../../featureFlags';
import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';
import Show from './Show.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/wgpt-social-media-posts'),
      name: 'social_media_posts_overview',
      component: Index,
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_SOCIAL_MEDIA_POSTS,
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/wgpt-social-media-posts/:inboxId'),
      name: 'social_media_posts_inbox',
      component: Index,
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_SOCIAL_MEDIA_POSTS,
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/wgpt-social-media-posts/:inboxId/posts/:postId'
      ),
      name: 'social_media_posts_show',
      component: Show,
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_SOCIAL_MEDIA_POSTS,
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
